/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable no-restricted-globals */
/* eslint-disable n/no-callback-literal */
/* eslint-disable @typescript-eslint/no-magic-numbers */

const isIE10 = function () {
  const userAgent = window.navigator.userAgent.toLowerCase()
  const match = /(?:msie|rv:)\s?([\d\\.]+)/.exec(userAgent)

  return match && parseInt(match[1], 10) >= 10
}

const isWebKitAndroid = function () {
  const userAgent = window.navigator.userAgent.toLowerCase()
  const match = /android\s([\d\\.]+)/.exec(userAgent)

  return match && parseFloat(match[1]) < 4.4
}

const _probeIncognito = function (callback: (res: boolean | null) => void) {
  const key = `test${new Date().getTime()}`

  // Chrome
  if (window.webkitRequestFileSystem && !isWebKitAndroid()) {
    window.webkitRequestFileSystem(
      window.TEMPORARY,
      1,
      () => {
        callback(false)
      },
      function () {
        callback(true)
      }
    )
  }
  // Firefox
  else if (window.indexedDB && /Firefox/.test(window.navigator.userAgent)) {
    try {
      const db = window.indexedDB.open(key)
      db.onerror = function () {
        callback(true)
      }
      db.onsuccess = function () {
        callback(false)
      }
    } catch (e) {
      callback(true)
    }
  }
  // IE10+
  else if (isIE10()) {
    try {
      callback(!window.indexedDB)
    } catch (e) {
      callback(true)
    }
  }
  // Safari
  else if (window.localStorage && /Safari/.test(window.navigator.userAgent)) {
    try {
      window.localStorage.setItem(key, '1')
      window.localStorage.removeItem(key)
      callback(false)
    } catch (e) {
      callback(true)
    }
  } else {
    callback(null)
  }
}

// TODO - can be replaced by https://www.npmjs.com/package/detectincognitojs
export const probeIncognito = (): Promise<boolean | null> =>
  new Promise((resolve) => _probeIncognito(resolve))
